import axios from "axios";
import { message } from "antd";

axios.interceptors.response.use(
  (response) => response,
  (error) => {

    const status = error.response.status;
    const data = error.response.data;

    let errorMessage = "Something went wrong";

    if (data?.message) {
      errorMessage = data.message;
    }

    switch (status) {
      case 400:
        message.error(errorMessage || "Bad Request");
        break;

      case 401:
        message.error("Unauthorized. Please login again.");
        break;

      case 403:
        message.error("Access denied.");
        break;

      case 404:
        message.error("Resource not found.");
        break;

      case 500:
        message.error("Internal server error.");
        break;

      default:
        message.error(errorMessage);
    }

    return Promise.reject(error);
  }
);